export const scheduleMap = (state) => {
  const date2ScheduleMap = {}
  state.schedules.forEach(schedule => {
    const date = schedule.date.split('-')
    date2ScheduleMap[`${date[0]}-${~~date[1]}-${~~date[2]}`] = schedule
  })
  return date2ScheduleMap
}

export const selectedItems = ({ value }, getters) => {
  const selectedItems = getters.scheduleMap[value.join('-')]
  return (selectedItems && selectedItems.sessions) || []
}



// WEBPACK FOOTER //
// ./src/store/schedules/getters.js